import { render } from "./MenuNuevo.vue?vue&type=template&id=a711eca4&scoped=true"
import script from "./MenuNuevo.vue?vue&type=script&lang=js"
export * from "./MenuNuevo.vue?vue&type=script&lang=js"

import "./MenuNuevo.vue?vue&type=style&index=0&id=a711eca4&lang=scss&scoped=true"

import exportComponent from "C:\\pirca\\Forge.Ruky\\PircaSolutions.Forge.Ruky.Backoffice.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a711eca4"]])

export default __exports__